import type { SwipeEventData } from "react-swipeable";

export function isIntentionalMonthSwipe({ absX, absY }: Pick<SwipeEventData, "absX" | "absY">): boolean {
    return absX >= 45 && absX > absY * 1.5;
}
